// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"f4-z"};